module.exports = __webpack_public_path__ + "static/media/401.ddb50f5d.png";